import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import api from '../../../config/axiosConfig'; // Assuming axiosConfig is set up for API calls

function AdminNavbar() {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');

    useEffect(() => {
        // Retrieve user data from local storage
        const userData = JSON.parse(localStorage.getItem('user'));
        if (userData && userData.username) {
            setUsername(userData.username);
        }
    }, []);

    const handleLogout = async () => {
        try {
            // Call the logout API endpoint
            await api.post('/signout'); // Replace with your backend's logout endpoint

            // Clear user data from local storage or context
            localStorage.removeItem('user');

            // Redirect to the login page
            navigate('/signin');
        } catch (error) {
            console.error('Error during logout:', error.response || error.message);
        }
    };

    return (
        <div className="adminnavbar">
            <div className="d-flex align-items-center justify-content-end p-4 gap-3">
                <span>Welcome, {username || 'Guest'}</span>
                <Button onClick={handleLogout}>Log Out</Button>
            </div>
        </div>
    );
}

export default AdminNavbar;
